import styled from "styled-components";
import { Flex } from "antd";

// ─── Pagination Footer Container ───────────────────────────────────────────────
// Flex handles: display, align-items, justify-content.
// styled adds the visual tokens (border, padding, background) + flex-shrink.

export const PaginationFooterContainerStyled = styled(Flex)`
  flex-shrink: 0;
  padding: 8px 16px;
  background: ${(p) => p.theme?.colors?.white ?? "#ffffff"};
  border-top: 1px solid ${(p) => p.theme?.colors?.borderLight ?? "#E5E7EB"};
`;

// ─── Total Text ────────────────────────────────────────────────────────────────
// Flex handles: display, align-items, gap.
// styled adds typography tokens (font-size, color).

export const PaginationTotalTextStyled = styled(Flex)`
  font-size: 14px;
  color: ${(p) => p.theme?.colors?.gray ?? "#565E70"};
`;
